module.exports = __webpack_public_path__ + "img/home_header_image.338e45df.jpg";